const statusToMessage = {
    '-1': {color: '#f43838', label: 'Verification Failed'},
    '1':  {color: '#aaaaaa', label: 'Verification In Progress'},
    '2':  {color: '#51a350', label: 'Ready For Submission'},
    '3':  {color: '#51a350', label: 'Submitted'},
    '4':  {color: '#51a350', label: 'Completed'},
    '5':  {color: '#ff7f00', label: 'Needs Review'},
}

const numericToStringStatus = {
    '-1': 'verification_failed',
    '1': 'verification',
    '2': 'ready_for_submission',
    '3': 'submitted',
    '4': 'completed',
    '5': 'rejected',
}

const stringToNumericStatus = {
    'verification_failed': -1,
    'verification': 1,
    'ready_for_submission': 2,
    'submitted': 3,
    'completed': 4,
    'rejected': 5
}

export function getStatusMessage(status) {
    return statusToMessage[status]
}

export function getStringStatus(numericStatus) {
    return numericToStringStatus[numericStatus]
}

export function getNumericStatus(stringStatus) {
    return stringToNumericStatus[stringStatus]
}

export function isUncompleted(txn) {
    return [
        'verification',
        'ready_for_submission',
        'submitted',
        'rejected'].map(getNumericStatus).includes(txn.status)
}
